document.addEventListener('DOMContentLoaded', () => {
  let sliderPositions = {};
  console.log('slider.js loaded');

  // First debug: Check if we find any buttons
  const buttons = document.querySelectorAll(
    '[data-action="sliderNext"], [data-action="sliderPrev"]'
  );
  console.log('Found buttons:', buttons.length);

  buttons.forEach((el) => {
    // Debug: Log each button we're attaching to
    console.log('Attaching to button:', {
      controls: el.getAttribute('data-controls'),
      action: el.getAttribute('data-action'),
    });

    // Try both click and mouseup events
    ['click', 'mouseup'].forEach((eventType) => {
      el.addEventListener(eventType, (event) => {
        // Stop any potential event bubbling issues
        event.preventDefault();
        event.stopPropagation();

        console.log(`${eventType} event triggered!`);

        const id = el.getAttribute('data-controls');
        const action = el.getAttribute('data-action');
        const slider = document.getElementById(id);

        console.log('Click handled:', { id, action, sliderFound: !!slider });

        if (!slider) {
          console.error('Slider not found:', id);
          return;
        }

        const slides = slider.querySelectorAll('.slider__item');
        console.log('Slides found:', slides.length);

        if (!slides.length) {
          console.error('No slides found in slider');
          return;
        }

        let currentSlide = 0;

        // get all slide positions
        if (typeof sliderPositions[id] === 'undefined') {
          console.log('Calculating slide positions...');
          sliderPositions[id] = [];
          slider.querySelectorAll('.slider__item').forEach((item) => {
            const position = Math.round(item.getBoundingClientRect().left);
            sliderPositions[id].push(position);
            console.log('Added position:', position);
          });
        }

        const currentScrollLeft =
          parseFloat(slider.getAttribute('data-scrollLeft')) || 0;
        console.log('Current scroll position:', currentScrollLeft);

        // Find current slide
        for (let i = sliderPositions[id].length - 1; i >= 0; i--) {
          if (sliderPositions[id][i] >= currentScrollLeft) {
            currentSlide = i;
          }
        }
        console.log('Current slide:', currentSlide);

        // Calculate next slide
        if (action === 'sliderNext') {
          currentSlide = (currentSlide + 1) % slides.length;
        } else {
          currentSlide =
            currentSlide - 1 < 0 ? slides.length - 1 : currentSlide - 1;
        }
        console.log('Target slide:', currentSlide);

        // Use querySelector instead of getElementsByTagName
        const targetSlide = slides[currentSlide];
        if (targetSlide) {
          console.log('Scrolling to offset:', targetSlide.offsetLeft);
          slider.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth',
          });
        } else {
          console.error('Target slide not found');
        }
      });
    });
  });

  // Track scroll position
  const sliders = document.querySelectorAll('.slider');
  console.log('Found sliders:', sliders.length);

  sliders.forEach((el) => {
    el.setAttribute('data-scrollLeft', '0');

    el.addEventListener(
      'scroll',
      () => {
        el.setAttribute('data-scrollLeft', el.scrollLeft);
        console.log(`Slider ${el.id} scrolled to:`, el.scrollLeft);
      },
      { passive: true }
    );
  });

  // Debounce resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      console.log('Resetting slider positions');
      sliderPositions = {};
    }, 250);
  });
});
